var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { toggleMark } from "prosemirror-commands";
import markInputRule from "../lib/markInputRule";
import Mark from "./Mark";
var Underline = /** @class */ (function (_super) {
    __extends(Underline, _super);
    function Underline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Underline.prototype, "name", {
        get: function () {
            return "underline";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Underline.prototype, "schema", {
        get: function () {
            return {
                parseDOM: [
                    { tag: "u" },
                    {
                        style: "text-decoration",
                        getAttrs: function (value) { return value === "underline"; },
                    },
                ],
                toDOM: function () { return ["u", 0]; },
            };
        },
        enumerable: true,
        configurable: true
    });
    Underline.prototype.inputRules = function (_a) {
        var type = _a.type;
        return [markInputRule(/(?:__)([^_]+)(?:__)$/, type)];
    };
    Underline.prototype.keys = function (_a) {
        var type = _a.type;
        return {
            "Mod-u": toggleMark(type),
        };
    };
    Object.defineProperty(Underline.prototype, "toMarkdown", {
        get: function () {
            return {
                open: "__",
                close: "__",
                mixable: true,
                expelEnclosingWhitespace: true,
            };
        },
        enumerable: true,
        configurable: true
    });
    Underline.prototype.parseMarkdown = function () {
        return { mark: "underline" };
    };
    return Underline;
}(Mark));
export default Underline;
